import React from "react";
import "../css/Common.css";
import "../css/SecurityAlert.css";
import { CONTACT_EMAIL, CONTACT_NUMBER } from "../Utils/constant";

const SecurityAlert = () => {
  return (
    <div className="page_wrapper security-alert-page-wrapper">
      <div className="security-alert-page">
        <div className="security-alert-container">
          <div className="security-alert-header">
            <span className="security-alert-icon">⚠️</span>
            <h1>Security Alert / सुरक्षा चेतावनी</h1>
          </div>

          <div className="security-alert-content">
            <p>
              <strong>English:</strong> Fraudsters are sending fake payment requests via WhatsApp, SMS, and social media, impersonating <span className="highlight">snappaisa.com</span> employees. Stay alert:
            </p>
            <p>
              <strong>हिंदी:</strong> धोखेबाज़ WhatsApp, SMS और सोशल मीडिया के माध्यम से नकली भुगतान अनुरोध भेज रहे हैं, जो <span className="highlight">snappaisa.com</span> के कर्मचारियों के रूप में पहचान बना रहे हैं। सतर्क रहें:
            </p>

            <ul>
              <li>
                <strong>English:</strong> Do not click unknown links or reply to suspicious messages.
                <br />
                <strong>हिंदी:</strong> अज्ञात लिंक पर क्लिक न करें या संदिग्ध संदेशों का जवाब न दें।
              </li>
              <li>
                <strong>English:</strong> Verify email IDs and domains before engaging.
                <br />
                <strong>हिंदी:</strong> संलग्न होने से पहले ईमेल ID और डोमेन सत्यापित करें।
              </li>
              <li>
                <strong>English:</strong> Be cautious of calls or messages claiming to be from us.
                <br />
                <strong>हिंदी:</strong> हमारे होने का दावा करने वाले कॉल या संदेशों से सावधान रहें।
              </li>
            </ul>

            <div className="warning-box">
              <p>
                <strong>English:</strong> <span className="highlight">snappaisa.com</span> is not responsible for losses from payments to unverified persons or links.
              </p>
              <p>
                <strong>हिंदी:</strong> <span className="highlight">snappaisa.com</span> अप्रमाणित व्यक्तियों या लिंक को भुगतान से होने वाले नुकसान के लिए जिम्मेदार नहीं है।
              </p>
            </div>

            <h2>Safe Payment / सुरक्षित भुगतान</h2>
            <p>
              <strong>हिंदी:</strong> भुगतान केवल हमारी आधिकारिक वेबसाइट <span className="highlight">snappaisa.com</span> या अधिकृत लिंक से करें।
            </p>
            <p>
              <strong>English:</strong> Pay only through our official website <span className="highlight">snappaisa.com</span> or authorized link.
            </p>
            <p>
              <strong>हिंदी:</strong> किसी अज्ञात नंबर/लिंक पर भरोसा न करें।
            </p>
            <p>
              <strong>English:</strong> Do not trust any unknown number/link.
            </p>

            <div className="contact-section">
              <h3>Official Contact / आधिकारिक संपर्क</h3>
              <p>Email: <span className="highlight">{CONTACT_EMAIL}</span></p>
              <p>Phone: <span className="highlight">+91 {CONTACT_NUMBER}</span></p>
              <p>Website: <span className="highlight">snappaisa.com</span></p>
            </div>

            <p className="signature">- Team SnapPaisa</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SecurityAlert;

